module.exports = __webpack_public_path__ + "img/btn.fb518334.png";